var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconLikeFill = function SvgIconLikeFill(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m8 14.233-.967-.88c-3.433-3.113-5.7-5.166-5.7-7.686A3.63 3.63 0 0 1 5 2c1.16 0 2.273.54 3 1.393A4 4 0 0 1 11 2a3.63 3.63 0 0 1 3.667 3.667c0 2.52-2.267 4.573-5.7 7.693z"
  })));
};
export default SvgIconLikeFill;